import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import {
  getFilterName,
  getFilterOpenedState,
  getFilterRangeMax,
  getFilterRangeMaxLength,
  getFilterRangeMin,
  getFilterRangeValueFromRaw,
  getFilterRangeValueToRaw,
} from 'store/ProductCatalog/filters/selectors';
import { setRangeFilterValues } from 'store/ProductCatalog/filters/actions';
import { Slider } from 'bricks';

import { limitValue } from './helpers';
import FiltersHeader from '../FiltersHeader';
import SmartRangeFilterInputs from './RangeFilterInputs';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const RangeFilterLayout = ({
  name,
  min,
  max,
  slug,
  valueFrom,
  valueTo,
  onValueChange,
  isMobile,
  className,
  isOpen,
}) => {
  const correctedMinValue = valueFrom ? limitValue(valueFrom, min, valueTo || max) : min;
  const correctedMaxValue = valueTo ? limitValue(valueTo, correctedMinValue, max) : max;

  return (
    <div className={cx('filter', isMobile && 'mobile', className)}>
      <FiltersHeader {...{ isMobile, name, slug, isOpen }} />
      {isOpen ?
        <div className={cx('options')}>
          <Slider
            {...{ min, max }}
            valueFrom={correctedMinValue}
            valueTo={correctedMaxValue}
            /** if we hit left side of slider, or right side of slider, we just pass null as no limit */
            onMinValueChange={(value) => onValueChange({ valueFrom: value === min ? null : value })}
            onMaxValueChange={(value) => onValueChange({ valueTo: value === max ? null : value })}
            isLabelled
            isFormatted
            onClickChangeSlider="nearest"
            slidersMeetResolveWay="move"
          />
          <SmartRangeFilterInputs {...{ min, max, valueFrom, valueTo, onValueChange, isMobile }} />
        </div>
      : null}
    </div>
  );
};

RangeFilterLayout.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  name: PropTypes.string,
  slug: PropTypes.string,
  onValueChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  maxInputLength: PropTypes.number,
  valueFrom: PropTypes.number,
  valueTo: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => ({
  isOpen: getFilterOpenedState(state, ownProps.slug),
  name: getFilterName(state, ownProps.slug),
  min: getFilterRangeMin(state, ownProps.slug),
  max: getFilterRangeMax(state, ownProps.slug),
  maxInputLength: getFilterRangeMaxLength(state, ownProps.slug),
  valueFrom: getFilterRangeValueFromRaw(state),
  valueTo: getFilterRangeValueToRaw(state),
});

const mapDispatchToProps = {
  onValueChange: setRangeFilterValues,
};

const RangeFilter = connect(mapStateToProps, mapDispatchToProps)(RangeFilterLayout);
RangeFilter.propTypes = {};
export default RangeFilter;
